// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFound__root--nK5l {
    overflow: hidden;
    text-align: center;
}

.NotFound__title--AGR0 {
    font-size: 34px;
    font-weight: 700;
    line-height: 44px;
    color: var(--secondary-color);
    margin-bottom: 8px;
}

.NotFound__label--iijY {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: var(--secondary-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/NotFound/NotFound.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC","sourcesContent":[".root {\n    overflow: hidden;\n    text-align: center;\n}\n\n.title {\n    font-size: 34px;\n    font-weight: 700;\n    line-height: 44px;\n    color: var(--secondary-color);\n    margin-bottom: 8px;\n}\n\n.label {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    color: var(--secondary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NotFound__root--nK5l`,
	"title": `NotFound__title--AGR0`,
	"label": `NotFound__label--iijY`
};
export default ___CSS_LOADER_EXPORT___;
